/**
 * Script personalizado para estilizar el buscador como en la imagen de referencia
 * y asegurar que tenga ancho completo solo en desktop
 */

document.addEventListener('DOMContentLoaded', function() {
  // Función para aplicar estilos al buscador
  function styleSearch() {
    // Aplicar estilos a los contenedores de búsqueda (independiente del ancho de pantalla)
    const searchWrappers = document.querySelectorAll('.search__input-wrap');
    searchWrappers.forEach(wrapper => {
      wrapper.style.position = 'relative';
      wrapper.style.border = '1px solid #cccccc'; // Borde gris más visible
      wrapper.style.borderRadius = '50px';
      wrapper.style.background = '#f1f1f1'; // Fondo gris claro #f1f1f1
      wrapper.style.overflow = 'hidden';
      wrapper.style.boxShadow = '0 2px 5px rgba(0,0,0,0.05)';
    });
    
    // Aplicar estilos a los inputs de búsqueda
    const searchInputs = document.querySelectorAll('.search__input');
    searchInputs.forEach(input => {
      input.style.border = 'none';
      input.style.padding = '10px 20px 10px 40px'; // Más padding a la izquierda para el icono
      input.style.background = 'transparent';
      input.style.height = '40px';
      input.style.fontSize = '14px';
      input.style.boxShadow = 'none';
      input.style.color = '#333'; // Color de texto oscuro para mejor contraste
    });
    
    // Aplicar estilos a los botones de búsqueda
    const searchButtons = document.querySelectorAll('.btn--search');
    searchButtons.forEach(button => {
      button.style.position = 'absolute';
      button.style.left = '5px'; // Cambiado a la izquierda
      button.style.right = 'auto'; // Eliminar la posición derecha
      button.style.top = '50%';
      button.style.transform = 'translateY(-50%)';
      button.style.background = 'transparent';
      button.style.border = 'none';
      button.style.color = '#777';
      button.style.padding = '8px 10px';
      button.style.zIndex = '2';
    });
    
    // Solo aplicar ancho completo en desktop
    if (window.innerWidth >= 990) {
      const searchContainers = document.querySelectorAll('.site-header__search-container, .site-header__search, .site-header__search .page-width, predictive-search');
      
      // Aplicar estilo a todos los contenedores de búsqueda
      searchContainers.forEach(container => {
        container.style.width = '100%';
        container.style.maxWidth = '100%';
      });
      
      // Aplicar estilo específicamente a los formularios de búsqueda
      const searchForms = document.querySelectorAll('.site-header__search form, predictive-search form');
      searchForms.forEach(form => {
        form.style.width = '100%';
        form.style.maxWidth = '100%';
      });
    }
  }
  
  // Ejecutar la función inmediatamente
  styleSearch();
  
  // También ejecutar después de un retraso para asegurarse de que todos los elementos estén cargados
  setTimeout(styleSearch, 500);
  
  // También ejecutar cuando el tamaño de la ventana cambie
  window.addEventListener('resize', styleSearch);
});
